module.exports = __webpack_public_path__ + "img/5.3c9d53e8.png";